export {CONTRACT_CELL_WIDTH} from '../../contracts/components/constants';

export const CHANGELOG_CELL_WIDTH = {
    date: 100,
    type: 120,
    credit: 120,
    separator: 20,
    changedBy: 150,
};

export const DATE_NAMES = {
    startDate: 'startDate',
    endDate: 'endDate',
};
export type DateNames = typeof DATE_NAMES[keyof typeof DATE_NAMES];

export const CONFIRM = {
    DATES: 'DATES',
    CREDITS: 'CREDITS',
};
export type ConfirmTypes = typeof CONFIRM[keyof typeof CONFIRM];
